import { render, staticRenderFns } from "./DashboardVisitasNAdmin.vue?vue&type=template&id=2bc2e628&scoped=true"
import script from "./DashboardVisitasNAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardVisitasNAdmin.vue?vue&type=script&lang=js"
import style0 from "./DashboardVisitasNAdmin.vue?vue&type=style&index=0&id=2bc2e628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc2e628",
  null
  
)

export default component.exports